const authNotAllowedMessage = () => window.I18n.t("auth_not_allowed")

const APPLICATION_ERROR_MESSAGES = {
  401: authNotAllowedMessage,
  403: authNotAllowedMessage,
  404: () => window.I18n.t("errors.not_found.heading"),
}

const unexpectedErrorMessage = () => window.I18n.t("errors.messages.unexpected_error")

// The `error` field mixes display text with symbolic codes. Ignore the codes so the HTTP status selects the fallback.
const SYMBOLIC_ERROR_CODES = new Set(["restricted_access", "not_found", "no_active_customer"])

export const XHR = (controller) => {
  Object.assign(controller, {
    async fetch(resource, options = {}) {
      options.headers = {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "text/html, application/json, application/vnd.api+json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        ...options.headers,
      }

      const response = await fetch(resource, options)
      response.applicationError = null
      response.redirectHandled = false

      if (Object.hasOwn(APPLICATION_ERROR_MESSAGES, response.status) || response.status >= 500) {
        response.applicationError = await this._applicationError(response)
      }

      return response
    },

    async _applicationError(response) {
      const location = response.status === 401 && response.headers.get("Location")
      if (location && this._sameOrigin(location)) {
        window.location.replace(location)
        response.redirectHandled = true
      }

      const contentType = response.headers.get("Content-Type") || ""
      const isJson = contentType.includes("application/json") || contentType.includes("application/vnd.api+json")
      // Explicitly marked HTML 4xx responses are renderable partials, so leave their body for the caller.
      const isRenderableHtmlError =
        response.status >= 400 &&
        response.status < 500 &&
        contentType.includes("text/html") &&
        response.headers.get("X-Enectiva-Renderable-Error") === "true"

      if (isRenderableHtmlError || (!isJson && response.redirectHandled)) return null

      let json = null
      if (isJson) {
        try {
          json = await response.clone().json()
        } catch (error) {
          console.error("Response is not JSON", error)
        }
      }

      if (!response.redirectHandled && json?.redirect) {
        window.location.replace(json.redirect)
        response.redirectHandled = true
      }

      const applicationError = { message: this._applicationErrorMessage(response.status, json) }
      if (json?.error === "no_active_customer") {
        applicationError.code = json.error
      }

      return applicationError
    },

    _applicationErrorMessage(status, json) {
      const jsonApiError = json?.errors?.[0]
      const message =
        json?.message ||
        jsonApiError?.detail ||
        jsonApiError?.title ||
        (!SYMBOLIC_ERROR_CODES.has(json?.error) && json?.error)

      if (typeof message === "string" && message.length > 0) {
        return message
      }

      return (APPLICATION_ERROR_MESSAGES[status] || unexpectedErrorMessage)()
    },

    _sameOrigin(location) {
      try {
        return new URL(location, window.location.href).origin === window.location.origin
      } catch {
        return false
      }
    },
  })
}
